import { AnyAction, combineReducers, configureStore } from '@reduxjs/toolkit'
import { logout } from './slices/auth'
import chartSlice from './slices/chart'
import consumptionSlice from './slices/consumption'
import exportSlice from './slices/export'
import propSlice, { saveStateMiddleware } from './slices/props'
import toastSlice from './slices/toast'
import treeSlice from './slices/tree'

const appReducer = combineReducers({
	export: exportSlice,
	tree: treeSlice,
	props: propSlice,
	chart: chartSlice,
	toast: toastSlice,
	consumption: consumptionSlice,
	// Добавьте другие срезы по необходимости
})

const rootReducer = (state: any, action: AnyAction) => {
	if (action.type === logout.type) {
		// Здесь вы можете сохранить какие-либо данные перед сбросом, если необходимо
		// Например, токен авторизации из localStorage
		// const { auth } = state;
		state = undefined // Сбрасываем весь state
	}
	return appReducer(state, action)
}

const store = configureStore({
	reducer: rootReducer,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware().concat(saveStateMiddleware),
	devTools: process.env.NODE_ENV !== 'production' ? { maxAge: 50 } : false, // Отключение DevTools в продакшн-окружении.
})

export default store
